module.exports = __webpack_public_path__ + "static/assets/dc317d085825b6a62bbd0d9100f0ba52.png";